const baseStyle = {
    control: {
        bg: 'sp.white',
    },
}

export const Checkbox = {
    baseStyle,
}
